//const BASE_URL = "http://localhost:5001/api";
//const BASE_URL="https://exim-staging-api.pyther.com/api"
//live for login count https://api-v1.apifdf.com/api/auth/get-login-details
const BASE_URL = "https://api-v1.apifdf.com/api";

export const loginAdmin = async (email, password) => {
  try {
    const response = await fetch(`${BASE_URL}/auth/admin-login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ apiTitle: "Pharmaceuticals", email, password }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Login failed");
    }

    const data = await response.json();
   

    return data;
  } catch (error) {
    throw error;
  }
};
//1- company data fetch
export const getCompanyData = async (count = 0, body = {}) => {
  try {
    const token = localStorage.getItem("token");

    const response = await fetch(`${BASE_URL}/users/company-stats`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
        count: count, //
      },
      body: JSON.stringify(body), //
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Failed to fetch company data");
    }
    return data;
  } catch (error) {
    throw error;
  }
};
export const getUsersFromCompanyName = async (companyName) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${BASE_URL}/users/get-users-from-company`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({ companyName }), // matches old site
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Failed to fetch users for company");
    }
    return data; // should be array of user objects
  } catch (error) {
    throw error;
  }
};
// 3. addFieldInCompanyUsers
export const addFieldInCompanyUsers = async (payloadData) => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(`${BASE_URL}/users/add-company-user-fields`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(payloadData),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Failed to update company field");
    }
    return data; // should be { success: true, message: "..." }
  } catch (error) {
    throw error;
  }
};
//4- user data fetch without count
export const searchUser = async (value = "", body = {}) => {
  try {
    const token = localStorage.getItem("token");

    const { page, limit, ...restBody } = body;

    const payload = {
      ...(page !== undefined && { page }),
      ...(limit !== undefined && { limit }),
      ...restBody,
    };

    const response = await fetch(
      `${BASE_URL}/users/search${value.startsWith("?") ? value : "?" + value}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Failed to search users");
    }

    return data;
  } catch (error) {
    throw error;
  }
};
export const getUserData = async (offset = 0, count = 0, industry = "") => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  params.append("offset", offset);
  if (industry) params.append("industry", industry);

  const url = `${BASE_URL}/users?${params.toString()}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: token,
      count: count.toString(),
      industry: industry,
    },
  });

  const data = await response.json();
  if (!response.ok)
    throw new Error(data.message || "Failed to fetch user data");
  return data;
};
//to logout user
export const logoutUser = async (id) => {
  try {
    const token = localStorage.getItem("token");

    const response = await fetch(`${BASE_URL}/users/logout/${id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({}),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Logout failed");
    }

    return data;
  } catch (error) {
    throw error;
  }
};

export const getUserActivity = async (industry = "") => {
  try {
    const token = localStorage.getItem("token");

    const response = await fetch(`${BASE_URL}/users/activity`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({ industry }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to fetch user activity");
    }

    return data;
  } catch (error) {
    throw error;
  }
};
//User Search count from customers screen
export const getSearchCountList = async () => {
  try {
    const token = localStorage.getItem("token");
    // console.log("TOKEN IN API SERVICE getSearchCountList:", token);
    const response = await fetch(`${BASE_URL}/users/get-search-count-list`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to fetch search count list");
    }

    return data;
  } catch (err) {
    throw err;
  }
};
//Getting Single User By ID
export const getUserById = async (id) => {
  try {
    const token = localStorage.getItem("token");

    const response = await fetch(`${BASE_URL}/users/${id}`, {
      method: "GET",
      headers: {
        Authorization: token,
      },
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.message || "Failed to fetch user");

    return data;
  } catch (err) {
    throw err;
  }
};
//Update User
export const updateUserById = async (id, body = {}) => {
  try {
    const token = localStorage.getItem("token");

    const response = await fetch(`${BASE_URL}/users/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.message || "Failed to update user");

    return data;
  } catch (err) {
    throw err;
  }
};
//change User Password
export const changePassword = async (id, body = {}) => {
  try {
    const token = localStorage.getItem("token");

    const response = await fetch(`${BASE_URL}/users/change-password/${id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.message || "Password update failed");

    return data;
  } catch (err) {
    throw err;
  }
};
// Delete User
export const deleteUserById = async (id) => {
  try {
    const token = localStorage.getItem("token");

    const response = await fetch(`${BASE_URL}/users/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: token,
      },
    });

    const data = await response.json();
    if (!response.ok) throw new Error(data.message || "Delete failed");

    return data;
  } catch (err) {
    throw err;
  }
};
//Day Search Count
export const getDaySearchCount = async (body = {}) => {
  try {
    const token = localStorage.getItem("token");

    const response = await fetch(`${BASE_URL}/search-count/day-search-count`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    });

    const data = await response.json();
    if (!response.ok)
      throw new Error(data.message || "Failed to fetch search count");

    return data;
  } catch (err) {
    throw err;
  }
};
// Get login details (for admin users)
export const getLoginDetails = async (body = {}) => {
  try {
    // Always include role: "admin" to satisfy backend check
    const payload = {
      role: "admin",
      ...body, // allows optional { userId } or {}
    };

    const response = await fetch(`${BASE_URL}/auth/get-login-details`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to get login details");
    }

    return data; // { response: true, result: [...] }
  } catch (err) {
    throw err;
  }
};

export const getAdminPanelCountsAPI = async () => {
  try {
    const token = localStorage.getItem("token");

    const response = await fetch(`${BASE_URL}/users/admin-dashboard-counts`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    const data = await response.json();

    if (!response.ok)
      throw new Error(data.message || "Failed to fetch admin panel counts");
    return data;
  } catch (error) {
    throw error;
  }
};

export const getIndustryLeadsCounts = async () => {
  try {
    const token = localStorage.getItem("token");

    const response = await fetch(`${BASE_URL}/industry/leads-counts`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    const data = await response.json();

    if (!response.ok)
      throw new Error(data.message || "Failed to fetch leads counts");
    return data;
  } catch (error) {
    throw error;
  }
};

// Get top most searched terms
export const getMostSearchedCount = async () => {
  try {
    const token = localStorage.getItem("token");

    const response = await fetch(
      `${BASE_URL}/search-count/most-searched-count`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to fetch most searched terms");
    }

    return data; // Returns array: [{ key: "term", count: 123 }, ...]
  } catch (err) {
    console.error("Error in getMostSearchedCount:", err);
    throw err;
  }
};

export async function getDailyAnalytics() {
  try {
    const response = await fetch(`${BASE_URL}/analysis/daily-analytics`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch daily analytics");
    }

    return await response.json();
  } catch (error) {
    console.error("getDailyAnalytics error:", error);
    return [];
  }
}

// Get today's failed login attempts (raw logs)
export const getTodayFailedLoginsAPI = async (date) => {
  try {
    const token = localStorage.getItem("token");

    // Validate date before sending
    if (!date) {
      throw new Error("Date is required");
    }

    const url = `${BASE_URL}/failed-login-count/day-wise?date=${encodeURIComponent(
      date
    )}`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(
        data.message || "Failed to fetch failed logins for the given date"
      );
    }

    return data; // { success, count, data: [...] }
  } catch (err) {
    console.error("getFailedLoginsByDateAPI error:", err);
    throw err;
  }
};

// Get all failed login attempts (raw logs)
export const getAllFailedLoginsAPI = async () => {
  try {
    const token = localStorage.getItem("token");

    const response = await fetch(`${BASE_URL}/failed-login-count/all`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || "Failed to fetch failed logins");
    }

    return data;
  } catch (err) {
    console.error("getAllFailedLoginsAPI error:", err);
    throw err;
  }
};

export const getTopUsersDaily = async (params, token) => {
  const queryParams = new URLSearchParams();

  if (params.date) {
    queryParams.append('date', params.date);
  } else if (params.startDate && params.endDate) {
    queryParams.append('startDate', params.startDate);
    queryParams.append('endDate', params.endDate);
  } else {
    throw new Error("Provide either 'date' or both 'startDate' and 'endDate'");
  }

  try {
    const response = await fetch(
      `${BASE_URL}/search-count/top-users-daily?${queryParams}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token, 
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || `Failed to fetch top users: ${response.status}`);
    }

    return await response.json(); 
  } catch (error) {
    throw error;
  }
};
